/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */

import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Autocomplete, Box, Button, Grid, IconButton, MenuItem, TextField, ThemeProvider } from '@mui/material';
import { ColumnConfig, DiagnosisMaster, GroupConfig, TableRowData } from '../../types'; 
import { diagnosistype, DiagnosisTypeEnum, fetchMedicalHistoryMasterData, getDiagnosis, getDoctors, initialDiagnosis, PatientDiagnosis, PatientDiagnosisValidationSchema, postDiagnosis, User} from './diagnosisHelper';
import { ConfirmationModal } from '../confirmationModal';
import { useAlert } from '../alertProvider';
import { useLoader } from '../loaderProvider/loader';
import { patientDetailsObservable } from '../../services/sharedService';
import { Field, FieldArray, FieldProps, Form, Formik, FormikErrors } from 'formik';
import { theme } from '../Medical_History_Forms/themeprovider';
// import DeleteIcon from '@mui/icons-material/Delete';
import { ReactComponent as DeleteIcon } from '../../assets/SVG/trash.svg';
import HPIBack from '../../assets/SVG/HPIBack.svg';
import { usePatientContext } from '../SubPatinetProvider';
import { usePatientContext as MainPatientContext } from '../patinetProvider';
import { RequiredLabel } from '../../utils/commonUtils';
import { DropdownOption, mapDropdownOptions } from '../Medical_History_Forms/MenstrualHistory/MenstrualHistory.helpers';
import { useTranslation } from 'react-i18next';


interface AddDiagnosisProps {
  onBackClick: () => void;
  data: any; // This is the prop you're passing (the selected data)
}

const AddDiagnosis: React.FC<AddDiagnosisProps> = ({ onBackClick, data }) => {
  const { t: tGeneral } = useTranslation('general');
  const { t: tInvestigation } = useTranslation('investigation_config');
  const [inputValue, setInputValue] = useState(''); // State for input value
  const [diagnosis, setDiagnosis] = useState<DiagnosisMaster[]>([]);
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null);
  const [doctors, setDoctors] = useState<User[]>([]);
  const [initialValues, setInitialValues] = useState<{ diagnosis: diagnosistype[] }>({ diagnosis: [initialDiagnosis],  });
  const { patientId } = usePatientContext();
  const { MainpatientDetails } = MainPatientContext();
  const { addAlert } = useAlert();
  const { showLoader, hideLoader } = useLoader();
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false); 
  const [deleteConfirmIndex, setDeleteConfirmIndex] = useState<number | null>(null);
  const removeRef = useRef<((index: number) => void) | null>(null);
  const contentMessage = tInvestigation('AreYouSureYouWantToSaveDiagnosis');
  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
  const [patientDetails, setpatientDetails] = useState<any >(null);
  const [dropdownOptionsForDiagnosis, setDropdownOptionsForDiagnosis] = useState<{
    diagnosis_type: DropdownOption[];
   
    }>({
      diagnosis_type: [],
   
    });
  
  

  useEffect(() => {
    const subscription = patientDetailsObservable.subscribe((value) => {
      setpatientDetails(value);
    });

    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    try {
      getDoctors()
        .then((res) => {
          setDoctors(res.objects);
        })
        .catch((error) => {
          console.error('Failed to fetch doctors:', error);
        });
    } catch (error) {
      console.error('Failed to fetch doctors:', error);
    }
  }, []);

  useEffect(() => {
    fetchMedicalHistoryMasterData(
      'diagnosis_type'
    )
      .then((response) => {
        setDropdownOptionsForDiagnosis({
          diagnosis_type: mapDropdownOptions(response?.diagnosis_type),
        });
      })
      .catch((err) => {
         
        console.error('Error fetching medical history masters', err);
      });
  }, []);

  const handleSelectionChange = (
    value: any,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => Promise<void | FormikErrors<{ diagnosis: diagnosistype[]; }>>,
    values: { diagnosis: any[] }
  ) => {
    if (value) {
      const filteredDiagnosis = values.diagnosis.filter(
        (diagnosis) => diagnosis.diagnosis
      );
  
      const isDuplicate = filteredDiagnosis.some(
        (diagnosis) => diagnosis.diagnosis === value.id
      );
  
      if (isDuplicate) {
        addAlert(tInvestigation('ThisDiagnosisHasAlreadyBeenAdded'), 'info');
        return;
      }

      // Get default doctor from appointment if available
      const defaultDoctorId = MainpatientDetails?.appointment_doctor?.id || null;
 
      setFieldValue('diagnosis', [
        ...filteredDiagnosis,
        {
          patient: patientId,
          diagnosis: value.id,
          diagnosis_code: value.code,
          diagnosis_name: value.name,
          diagnosis_name_label: value.name_label || value.name,
          diagnosis_type: '',
          doctor: defaultDoctorId,
          notes: null,
        },
      ]);
    }
  };
  

  const onBack = () => {
    onBackClick();
  };

  const handleSearch = (searchValue: string) => {
    if (searchValue.length>0) {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      debounceTimeout.current = setTimeout(() => {
        const query = `?gender=${patientDetails.gender}&search=${searchValue}`;
        getDiagnosis(query).then((res) => {
          setDiagnosis(res.objects);
        });
      }, 300); // Adjust delay (e.g., 300ms) as needed
    }
  };

  

  const handleSubmit = (values: any, { setSubmitting, resetForm }: any) => {
    showLoader();
    const convertedData:PatientDiagnosis[] = values.diagnosis.map((test:any) => {
      
      return {
        ...(test.id && { id: test.id }),
        patient: test.patient,       
        diagnosis: test.diagnosis,            
        diagnosis_type: test.diagnosis_type as DiagnosisTypeEnum, 
        doctor:  test.doctor,
        notes: test.notes || ''
      };
    });
    
    Promise.all(convertedData.map(data => postDiagnosis(data)))
      .then(() => {
        addAlert(tInvestigation('DiagnosisAddedSuccessfully'), 'success');
        onBackClick();
        
      })
      .catch((error) => {
        console.error('An error occurred:', error);
        addAlert(tInvestigation('ErrorOccurredWhileSavingDiagnosis'), 'error');
      })
      .finally(()=>{
        hideLoader();
      });
  };
  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };
  useEffect(() => {
    if (data) {
      const doctor = doctors.find(doc => doc.id === data.doctor);
      
      setInitialValues({
        diagnosis: [{
          id: data.id,
          patient: patientId,
          diagnosis: data.diagnosis,
          diagnosis_code: data.diagnosis_code,
          diagnosis_name: data.diagnosis_name,
          diagnosis_type: data.diagnosis_type || '',
          doctor: doctor ? doctor.id : null, 
          notes: data.notes || '',
        }],
      });
    }
  }, [data, patientId, doctors]);

  const [missingFields, setMissingFields] = useState<{ [index: number]: string[] }>({});

  const handleOpenModal = (values: any) => {
    let allFieldsFilled = true;
    const updatedMissingFields: { [index: number]: string[] } = {};
    if (Array.isArray(values.diagnosis)) {
      values.diagnosis.forEach((row: any, index: number) => {
        const missingFields: string[] = [];
    
        if (!row.diagnosis_code) missingFields.push('diagnosis_code');
        if (!row.diagnosis_name) missingFields.push('diagnosis_name');
        if (!row.diagnosis_type) missingFields.push('diagnosis_type');
        if (!row.doctor) missingFields.push('doctor');
    
        if (missingFields.length > 0) {
          updatedMissingFields[index] = missingFields;
          allFieldsFilled = false;
        }
      });
    } else {
      console.error('values.diagnosis is undefined or not an array');
      allFieldsFilled = false;
    }
    setMissingFields(updatedMissingFields);
  
    if (allFieldsFilled) {
      setOpenConfirmDialog(true);
    }
  };
  
  
  
  console.log('dropdownOptionsForDiagnosis',dropdownOptionsForDiagnosis);

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true} 
      validationSchema={PatientDiagnosisValidationSchema}
      onSubmit={handleSubmit}
    >
      {({
        values,
        handleSubmit,
        handleChange,
        handleBlur,
        setFieldValue,
        isSubmitting,
        dirty,
        touched,
        errors,
        setFieldTouched,
        submitForm,
        validateForm,
      }) => {
        return (
          <>
            <ThemeProvider theme={{theme}}>
              <div data-testid="diagnosis-add-container">
                <Grid container spacing={2}>
                  <Grid item xs={5} display="flex" justifyContent="start">
                    <IconButton onClick={onBack} data-testid="diagnosis-add-back-button">
                      <img src={HPIBack} alt="Back" style={{ width: '2.5rem', height: '2.5rem' }} />
                    </IconButton>
                  </Grid>
                </Grid>
              </div>
              <Form  onSubmit={(e) => {
                e.preventDefault();
              }}>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={7}> {/* Occupies 6 out of 12 columns */}
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-start', // Aligns to the start
                          marginBottom: 5,
                        }}
                      >
                        <Autocomplete
                          disablePortal
                          fullWidth
                          options={inputValue.trim() ? diagnosis : []}
                          value={selectedDiagnosis}
                          inputValue={inputValue}
                          onChange={(e, value) => {
                            handleSelectionChange(value, setFieldValue, values);
                            setInputValue('');
                          }}
                          onInputChange={(e, value, reason) => {
                            if (reason !== 'reset') {
                              setInputValue(value);
                              handleSearch(value);
                            }
                          }}
                          getOptionLabel={(option) => `${option.code || ''} - ${option.name_label || option.name || ''}`}
                          renderOption={(props, option) => (
                            <li {...props}>
                              <span>{option.code}</span>&nbsp;-&nbsp;{option.name_label || option.name}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={tInvestigation('text_SearchByCodeOrName')}
                            />
                          )}
                          noOptionsText={null} // Don’t show any empty content when there are no options
                          open={Boolean(inputValue.trim()) && diagnosis.length > 0} // Only open if there are matches
                        />

                      </Box>
                    </Grid>
                  </Grid>
                  {/* Dynamic Fields for Diagnoses */}
                  <FieldArray
                    name="diagnosis"
                    render={({ remove }) => {
                      removeRef.current = remove;
                      return (
                        <>
                          {values.diagnosis.map((row, index) => (
                            <Grid container spacing={2} marginBottom={3} key={index} alignItems="center">

                              <Grid item xs={3} md={3} lg={3} xl={3}>
                                {values.diagnosis[index]?.diagnosis_code || values.diagnosis[index]?.diagnosis_name ? (
                                  <span>
                                    {(values.diagnosis[index]?.diagnosis_code ?? '') + '  ' + ((values.diagnosis[index]?.diagnosis_name_label || values.diagnosis[index]?.diagnosis_name) ?? '')}
                                  </span>
                                ) : (
                                  <>
                                    <Grid container spacing={1}>
                                      <Grid item xs={4}>
                                        <TextField
                                          value=""
                                          variant="outlined"
                                          size="small"
                                          fullWidth
                                          disabled
                                          InputLabelProps={{ shrink: Boolean(values.diagnosis[index]?.diagnosis_code) }}
                                          label={RequiredLabel(tInvestigation('DiagnosisCode'), true)}
                                          error={!!missingFields[index]?.includes('diagnosis_code') && !row.diagnosis_code}
                                          sx={{
                                            '& .MuiOutlinedInput-root': {
                                              '&.Mui-error fieldset': {
                                                borderColor: 'red', 
                                              },
                                            },
                                          }}
                                        />
                                      </Grid>
                                      <Grid item xs={8}>
                                        <TextField
                                          value=""
                                          variant="outlined"
                                          size="small"
                                          fullWidth                                  
                                          InputLabelProps={{ shrink: Boolean(values.diagnosis[index]?.diagnosis_name) }}
                                          disabled
                                          label={RequiredLabel(tInvestigation('DiagnosisName'), true)}
                                          error={!!missingFields[index]?.includes('diagnosis_name') && !row.diagnosis_name}
                                          sx={{
                                            '& .MuiOutlinedInput-root': {
                                              '&.Mui-error fieldset': {
                                                borderColor: 'red', 
                                              },
                                            },
                                          }}
                                        />
                                      </Grid>
                                    </Grid>
                                  </>
                                )}
                              </Grid>


                              <Grid item xs={2}>
                                <Field
                                  name={`diagnosis[${index}].diagnosis_type`}
                                  render={({ field }: FieldProps) => (
                                    <TextField
                                      {...field}
                                      label={RequiredLabel(tInvestigation('DiagnosisType'), true)}
                                      select
                                      variant="outlined"
                                      InputLabelProps={{ shrink: Boolean(values.diagnosis[index]?.diagnosis_type) }}
                                    
                                      size="small"
                                      value={row.diagnosis_type !== null ? row.diagnosis_type : ''}
                                      onChange={(event) => {
                                        setFieldValue(`diagnosis[${index}].diagnosis_type`, event.target.value);
                                      }}
                                      fullWidth
                                      error={!!missingFields[index]?.includes('diagnosis_type')&& !row.diagnosis_type} 
                                      sx={{
                                        '& .MuiOutlinedInput-root': {
                                          '&.Mui-error': {
                                            '& fieldset': {
                                              borderColor: 'red', 
                                            },
                                          },
                                        },
                                      }}
                                    >
                                      {dropdownOptionsForDiagnosis?.diagnosis_type.map((item) => (
                                        <MenuItem key={item.value} value={item.value}>
                                          {item.label}
                                        </MenuItem>
                                      ))}
                                    </TextField>
                                  )}
                                />
                              </Grid>

                              <Grid item xs={2}>
                                <Field
                                  name={`diagnosis[${index}].doctor`}
                                  render={({ field }: FieldProps) => (
                                    <Autocomplete
                                      options={doctors}
                                      getOptionLabel={(option) => `${option.first_name} ${option.last_name}`}
                                      value={doctors.find((doc) => doc.id === row.doctor) || null}
                                      onChange={(_e, value) => {
                                        setFieldValue(`diagnosis[${index}].doctor`, value ? value.id : null);
                                      }}
                                      size="small"
                                      fullWidth
                                      isOptionEqualToValue={(option, value) => option.id === value.id}
                                      data-testid={`diagnosis-add-doctor-${index}`}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={RequiredLabel(tInvestigation('Doctor'), true)}
                                          variant="outlined"
                                          error={
                                            Boolean(
                                              touched.diagnosis?.[index]?.doctor &&
                                            typeof errors.diagnosis?.[index] === 'object' &&
                                            errors.diagnosis?.[index]?.doctor
                                            ) || 
                                          (!!missingFields[index]?.includes('doctor') && !row.doctor)
                                          }
                                          sx={{
                                            '& .MuiOutlinedInput-root': {
                                              '&.Mui-error': {
                                                '& fieldset': {
                                                  borderColor: 'red',
                                                },
                                              },
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                  )}
                                />
                              </Grid>
                              {/* Notes */}
                              <Grid item xs={4} md={4} lg={4} xl={4}>
                                <Field
                                  name={`diagnosis[${index}].notes`}
                                  as={TextField}
                                  label={tGeneral('Notes')}
                                  variant="outlined"
                                  fullWidth
                                  multiline
                                  value={row.notes !== null ? row.notes : ''}
                                  InputLabelProps={{ shrink: Boolean(values.diagnosis[index]?.notes) }}
                                  inputProps={{ maxLength: 255 }}
                                  error={Boolean(
                                    (touched.diagnosis?.[index]?.notes &&
                                typeof errors.diagnosis?.[index] === 'object' &&
                                errors.diagnosis?.[index]?.notes) ||
                                (row.notes?.length || 0) > 255
                                  )}
                                  helperText={(row.notes?.length || 0) > 255 ? tGeneral('MaxCharacterLimit', 'Maximum 255 characters allowed') : ''}
                                  data-testid={`diagnosis-add-notes-${index}`}
                                />
                              </Grid>
                              {/* Remove Button */}
                              <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'flex-end'}}>
                                <IconButton 
                                  onClick={() => {
                                    setDeleteConfirmIndex(index);
                                  }}
                                  color="error"
                                  sx={{ textTransform: 'none' }}>
                                  <DeleteIcon />
                                </IconButton>
                              </Grid>
                            </Grid>
                          ))}
                        </>
                      );}} />
                </Box>
                {/* Submit Button */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2 }}>
                  <button
                    onClick={() => handleOpenModal(values)}
                    data-testid="diagnosis-add-save-button"
                    style={{
                      padding: '8px 10px',
                      border: 'none',
                      borderRadius: '7px',
                      fontSize: '16px',
                      fontWeight: '700',
                      backgroundColor:'#F4F4F4',
                      color:'#232323',
                      width: '100px'
                    }}
                  >
                    {tGeneral('Save')}
                  </button>
                </Box>
              </Form>
              <ConfirmationModal
                open={openConfirmDialog}
                handleClose={handleCloseConfirmDialog}
                onConfirm={() => {
                  setOpenConfirmDialog(false);
                  handleSubmit();
                }}
                type="save"
                title={tInvestigation('SaveDiagnosis')}
                contentMessage={contentMessage}
                data-testid="diagnosis-add-confirmation-modal"
              />
              <ConfirmationModal
                open={deleteConfirmIndex !== null}
                handleClose={() => setDeleteConfirmIndex(null)}
                onConfirm={() => {
                  if (deleteConfirmIndex !== null) {
                    if (values.diagnosis.length === 1) {
                      const hasValues = Object.values(values.diagnosis[0] || {}).some(
                        (val) => val !== null && val !== '' && val !== undefined
                      );
                      if (hasValues) {
                        setFieldValue('diagnosis[0]', {
                          diagnosis_code: '',
                          diagnosis_name: '',
                          diagnosis_type: '',
                          doctor: '',
                          notes: '',
                        });
                      } else {
                        addAlert(tInvestigation('AtLeastOneDiagnosisMustRemain'), 'warning');
                      }
                    } else {
                      removeRef.current?.(deleteConfirmIndex);
                    }
                  }
                  setDeleteConfirmIndex(null);
                }}
                type="warning"
                title={tInvestigation('DeleteDiagnosis')}
                contentMessage={tInvestigation('AreYouSureYouWantToDeleteDiagnosis')}
              />
            </ThemeProvider></>
        );
      }}
    </Formik>
  );

};

export default AddDiagnosis;
